import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { TransitionProps } from '@material-ui/core/transitions';
import { ArrowBackIosOutlined } from '@material-ui/icons';
import CreateStyle from 'containers/create-style/AddCreateStyleItem';
import AddOrSelectItem from 'containers/create-style/AddOrSelectItem';
import TextEditor from 'containers/create-style/CreateStyleCanvas/TextEditor';
import StyleInformation from 'containers/create-style/StyleInformation';
import PublishToConsumers from 'containers/create-style/StyleInformation/PublishToConsumers';
import PublishToUnlisted from 'containers/create-style/StyleInformation/PublishToUnlisted';
import AppVersion from 'containers/sidebar_content/app_version';
import ContactUs from 'containers/sidebar_content/contact_us/contact_us';
import FAQ from 'containers/sidebar_content/faq';
import Invite from 'containers/sidebar_content/invite';
import SettingContent from 'containers/sidebar_content/setting';
import React from 'react';
import { useSelector } from 'react-redux';
import themes from 'styles/themes';
import { RootState } from '../../redux/store';
import clsx from 'clsx';
import EditMyPhoto from 'containers/quiz_manager/my_photos/edit_my_photo';
import AddStyleForSession from 'containers/session_details/AddStyleOrItemForSession';
import { StylingSessionOutcomeType } from 'containers/session_details/type';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="right" ref={ref} {...props} />;
});
export const useStyles = makeStyles(() =>
    createStyles({
        paper: {
            background: themes.palette.primary.light,
            width: '100%',
            maxWidth: '1024px',
            margin: 'auto',
        },
        grayBg: {
            background: '#E6E6E6',
        },
    }),
);
interface IModalProps {
    handleClose: () => void;
    open: boolean;
    title: string | String;
    componentProps?: any;
    isEnableTitle?: boolean;
    item?: any;
    modal_code: ETitleModal;
    styleData?: any;
    sourceStyleData?: any;
    isEdit?: any;
    customContainerClass?: string;
}
export enum ETitleModal {
    FAQ = 'faq',
    CONTACT_US = 'contact',
    APP_VERSION = 'app_version',
    SETTING = 'setting',
    INVITE = 'invite',
    CREATE_STYLE = 'createStyleItem',
    ADD_OR_SELECT_ITEM = 'addOrSelectItem',
    STYLE_CREATED_INFO = 'styleCreatedInfomation',
    STYLE_INFO = 'styleInformation',
    PUBLISH_TO_UNLISTED = 'PUBLISH_TO_UNLISTED',
    PUBLISH_TO_CUSTOMER = 'PUBLISH_TO_CUSTOMER',
    TEXT_EDITOR = 'TEXT_EDITOR',
    EDIT_MY_PHOTO = 'EDIT_MY_PHOTO',
    ADD_STYLE_FOR_SESSION = 'ADD_STYLE_FOR_SESSION',
    ADD_ITEM_FOR_SESSION = 'ADD_ITEM_FOR_SESSION',
    ADD_STYLE_GUIDE_FOR_SESSION = 'ADD_STYLE_GUIDE_FOR_SESSION',
}

export default function ModalFull(props: IModalProps) {
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const classes = useStyles();
    const { componentProps, isEnableTitle = true, customContainerClass = false, handleClose } = props;
    const renderContent = (modal_code: ETitleModal) => {
        switch (modal_code) {
        case ETitleModal.FAQ:
            return <FAQ {...componentProps} />;
        case ETitleModal.CONTACT_US:
            return <ContactUs user={userDetail} />;
        case ETitleModal.APP_VERSION:
            return <AppVersion {...componentProps} />;
        case ETitleModal.SETTING:
            return <SettingContent {...componentProps} />;
        case ETitleModal.INVITE:
            return <Invite {...componentProps} />;
        case ETitleModal.CREATE_STYLE:
            return <CreateStyle styleData={props.styleData} {...componentProps} />;
        case ETitleModal.ADD_OR_SELECT_ITEM:
            return <AddOrSelectItem styleData={props.styleData} {...componentProps} />;
        case ETitleModal.STYLE_CREATED_INFO:
            return (
                <StyleInformation
                    {...componentProps}
                    styleData={props.styleData}
                    sourceStyleData={props.sourceStyleData}
                />
            );
        case ETitleModal.PUBLISH_TO_UNLISTED:
            return <PublishToUnlisted {...componentProps} />;
        case ETitleModal.PUBLISH_TO_CUSTOMER:
            return <PublishToConsumers {...componentProps} />;
        case ETitleModal.TEXT_EDITOR:
            return <TextEditor {...componentProps} />;
        case ETitleModal.EDIT_MY_PHOTO:
            return <EditMyPhoto {...componentProps} item={props.item} />;
        case ETitleModal.ADD_STYLE_FOR_SESSION:
        case ETitleModal.ADD_ITEM_FOR_SESSION:
            return (
                <AddStyleForSession
                    {...componentProps}
                    outcomeType={
                        modal_code === ETitleModal.ADD_STYLE_FOR_SESSION
                            ? StylingSessionOutcomeType.Style
                            : StylingSessionOutcomeType.Item
                    }
                    handleClose={handleClose}
                    visible={props.open}
                />
            );
        default:
            return;
        }
    };
    return (
        <div>
            <Dialog
                open={props.open}
                classes={{
                    paper: clsx(classes.paper, customContainerClass && classes[customContainerClass]),
                }}
                fullScreen
                TransitionComponent={Transition}
                keepMounted
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                {isEnableTitle && (
                    <DialogTitle
                        id="alert-dialog-slide-title"
                        style={{
                            textAlign: 'center',
                            position: 'relative',
                            padding: '10px 24px',
                        }}
                    >
                        <ArrowBackIosOutlined
                            style={{
                                color: themes.palette.primary.main,
                                position: 'absolute',
                                width: 20,
                                left: 28,
                                top: 17,
                            }}
                            onClick={props.handleClose}
                        />
                        <span
                            style={{
                                fontSize: 24,
                                fontWeight: 400,
                                margin: 0,
                                fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
                                color: themes.palette.primary.main,
                            }}
                        >
                            {props.title}
                        </span>
                    </DialogTitle>
                )}

                <DialogContent
                    style={{
                        padding: '0',
                    }}
                >
                    {renderContent(props.modal_code)}
                </DialogContent>
            </Dialog>
        </div>
    );
}
